<div class="nav-bar-container outer-bar">
    <div class="nav-bar inner-bar">
        <div class="component-container ">
            <!-- left -->
            <div class="left-container">
                <!--logo-->
                <logo-component></logo-component>
                <!-- disable the navigation links for poll matrix for now to see if that is the better solution-->
                <ng-container *ngIf="false">
                    <div *ngIf="pollService.pollIsLoaded()" class="navigation-links">
                        <a *ngIf="this.routeContextService.id === 'vote'"
                            routerLink="{{navigationService.getPathPollMatrix()}}" routerLinkActive="active-link"
                            class="navigation-link my-polls">{{ 'responseMatrix' |
                            transMigrated | async}}</a>
                        <a *ngIf="this.routeContextService.id !== 'vote'"
                            routerLink="{{navigationService.getPathVote()}}" class="navigation-link my-polls">{{ 'vote'
                            | transMigrated | async}}</a>
                    </div>
                </ng-container>
            </div>
            <!-- right -->
            <div class="right-container">
                <nav-menu-button [showGoToResponses]="this.routeContextService.id === 'vote'"
                    [showGoToVote]="this.routeContextService.id === 'pollMatrix'"
                    [color]="responsiveService.isScreenBig()?'primary':'xx'">
                </nav-menu-button>
            </div>
        </div>
    </div>
</div>
